import { Card, Heading } from '@george-labs.com/design-system';
import type { FC } from 'react';

import { Translation } from '@luna/i18n';

import { ProductServices } from './ProductServices';
import type { ProductService } from './types';

interface Props {
    services?: ProductService[];
}

export const ProductServicesCard: FC<Props> = ({ services }) => {
    if (!services || services.length === 0) {
        return null;
    }

    return (
        <>
            <Heading level={2} className="g-h3" data-cy="product-services-title">
                <Translation t="account.services" />
            </Heading>
            <Card data-cy="product-services-card">
                <ProductServices data-cy="product-services" services={services} />
            </Card>
        </>
    );
};
